/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandGraphql = createReactComponent("outline", "brand-graphql", "IconBrandGraphql", [["path", { "d": "M4 8l8 -5l8 5v8l-8 5l-8 -5z", "key": "svg-0" }], ["path", { "d": "M12 4l7.5 12h-15z", "key": "svg-1" }], ["path", { "d": "M11 3a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-2" }], ["path", { "d": "M11 21a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-3" }], ["path", { "d": "M3 8a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-4" }], ["path", { "d": "M3 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-5" }], ["path", { "d": "M19 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-6" }], ["path", { "d": "M19 8a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-7" }]]);

export { IconBrandGraphql as default };
//# sourceMappingURL=IconBrandGraphql.mjs.map
